// Feature switches for the website.

/** Blog links are hidden for now. The /blogs routes stay live so existing links
 * (e.g. the mobile app's trainer–trainee article) keep working. Set to true to show them again. */
export const SHOW_BLOGS = false;
